import { IAccountDocument } from '@epicuro-next/data/documents';
import { createAction, props } from '@ngrx/store';

export const loadTradeTerms = createAction('[User] Load Trade Terms');

export const loadTradeTermsSuccess = createAction(
  '[User] Load Trade Terms Success',
  props<{ documents: ReadonlyArray<IAccountDocument> }>(),
);

export const loadTradeTermsFailure = createAction(
  '[User] Load Trade Terms Failure',
);
